import React from 'react'
import SlotsSummaryChart from './SlotsSummaryChart'
import HourChart from './HourChart'
import BoxesMap from './BoxesMap'
import SlotEventsChart from './SlotEventsChart'
import PostalPlaceFilledChart from './PostalPlaceFilledChart'
import { Card, Flex } from 'antd'

export default function MultipleBoxCharts (slots, selectedBoxes) {
  const groupedCharts = (charts) => (
    <Card>
      <Flex justify='space-around'>
        {charts.map(Chart => <Chart slots={slots.filter(slot => (slot.type === 'PatientSlot' && slot.state === 'done'))} key={Chart.toString()} />) }
      </Flex>
    </Card>
  )

  return [
    { key: 'slotSummary', children: (<SlotsSummaryChart slots={slots} />) },
    { key: 'slotHour', children: (<HourChart slots={slots} />) },
    { key: 'boxesMap', children: (<BoxesMap slots={slots.filter(slot => slot.type === 'PatientSlot' && slot.state === 'done')} selectedBoxes={selectedBoxes} />) },
    { key: 'groupedCharts1', children: (groupedCharts([SlotEventsChart, PostalPlaceFilledChart])) }
  ]
}
